<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loadingCliente">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="cliente && !loadingCliente">
						<div class="col-12 p-5">
							<div class="grid card-simple">
								<div class="col-12 md:col-12">
									<h5>Dados Pessoais</h5>
								</div>
								<div class="form-group  col-12 md:col-2">
									<label class="label-superior">Código</label>
									<label class="label-inferior" id="id">{{ cliente.id }}</label>
								</div>

								<div class="form-group col-12 md:col-3">
									<label class="label-superior">Nome</label>
									<label class="label-inferior" id="nome">{{ cliente.nome }}</label>
								</div>

								<div class="form-group col-12 md:col-2">
									<label class="label-superior">Apelido</label>
									<label class="label-inferior" id="email">{{ cliente.apelido }}</label>
								</div>

								<div class="form-group col-12 md:col-3">
									<label class="label-superior">CPF</label>
									<label class="label-inferior" id="cpf">{{ cliente.cpf | cpfFormat }}</label>
								</div>

								<div class="form-group col-12 md:col-2">
									<label class="label-superior">Aniversário</label>
									<label class="label-inferior" id="aniversario">{{ cliente.aniversario | date:
										'dd/MM'}}</label>
								</div>

								<div class="form-group col-12 md:col-4">
									<label class="label-superior">E-mail</label>
									<label class="label-inferior" id="email">{{ cliente.email }}</label>
								</div>

								<div class="col-12 md:col-12">
									<h5>Endereço</h5>
								</div>

								<div class="form-group col-12 md:col-2">
									<label class="label-superior">CEP</label>
									<label class="label-inferior" id="cep">{{ cliente.cep }}</label>
								</div>

								<div class="form-group col-12 md:col-3">
									<label class="label-superior">Logradouro</label>
									<label class="label-inferior" id="logradouro">{{ cliente.logradouro }}</label>
								</div>

								<div class="form-group col-12 md:col-2">
									<label class="label-superior">Bairro</label>
									<label class="label-inferior" id="bairro">{{ cliente.bairro }}</label>
								</div>

								<div class="form-group col-12 md:col-2">
									<label class="label-superior">Número</label>
									<label class="label-inferior" id="numeroEndereco">{{
										cliente.numeroEndereco}}</label>
								</div>

								<div class="form-group col-12 md:col-3">
									<label class="label-superior">Complemento</label>
									<label class="label-inferior" id="complementoEndereco">{{
										cliente.complementoEndereco }}</label>
								</div>
								<div class="form-group col-12 md:col-1">
									<label class="label-superior">Estado</label>
									<label class="label-inferior" id="uf">{{ cliente.uf}}</label>
								</div>

								<div class="form-group col-12 md:col-4">
									<label class="label-superior">Cidade</label>
									<label class="label-inferior" id="cidade">{{ cliente.cidade }}</label>
								</div>

							</div>
						</div>


						

						<div class="w-full px-5">
							<div class="col-12 md:col-12">
								<h5>Contatos</h5>
							</div>
							<p-table #dt1 [value]="listaContatos" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">

								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex justify-content-between align-items-center">
												Número
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Identificador
											</div>
										</th>


										<th>
											<div class="flex justify-content-between align-items-center">
												Principal
											</div>
										</th>

									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.numero}}
										</td>
										<td>
											<label>{{item.identificacao ? item.identificacao : 'Não informado'}}</label>
										</td>

										<td>
											<label>{{item.principal ? 'Sim' : 'Não'}}</label>
										</td>


									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum contato cadastrado.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>

						<div class="col-12 mt-5 mb-3 px-5">
							<div class="grid card-simple">
								<div class="col-12 md:col-12">
									<h5>Dados adicionais</h5>
								</div>

								<div class="col-12 md:col-2">
									<label class="label-superior">Indicador</label>
									<label class="label-inferior" id="indicador">{{ cliente.indicadorCliente }}</label>
								</div>

								<div class="col-12 md:col-2">
									<label class="label-superior">Última comanda</label>
									<label class="label-inferior" id="ultimaComanda">{{ cliente.ultimaComanda | date:
										'dd/MM/yyyy hh:mm'
										}}</label>
								</div>

								<div class="col-12 md:col-2">
									<label class="label-superior">Cadastro</label>
									<label class="label-inferior" id="dataCriacao">{{ cliente.dataCriacao | date:
										'dd/MM/yyyy hh:mm' }}</label>
								</div>

								<div class="col-12 md:col-2">
									<label class="label-superior">Última atualização</label>
									<label class="label-inferior" id="dataAtualizacao">{{ cliente.dataAtualizacao |
										date: 'dd/MM/yyyy hh:mm'
										}}</label>
								</div>

								<div class="col-12 md:col-2">
									<label class="label-superior">Situação</label>
									<div class="label-inferior">
										<label class="product-badge status-instock" id="status"
											*ngIf="cliente.status">ATIVO</label>
										<label class="product-badge status-outofstock" id="status"
											*ngIf="!cliente.status">INATIVO</label>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loadingCliente">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/cliente"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>